import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    orderDetail: {
      type: Object,
      default: null
    },
    showRevokeOrder: {
      type: Boolean,
      dufault: false
    }
  },
  data: function data() {
    return {
      showDetailDec: {
        sectionNo: '标段(包)编号：',
        sectionName: '标段(包)名称：',
        submitDocumentsDeadline: '投标文件截止日期：',
        amountGuaranteed: '投标保证金(万元)：',
        validityBids: '投标有效期(天)：',
        guaranteePrice: "订单金额(元)：",
        refundFee: "退款手续费(元)：",
        actualRefund: "实际应退(元)："
      },
      showDetail: this.orderDetail,
      fileList: [],
      reason: '',
      isError: false //控制是否显示原因必填提示

    };
  },
  watch: {
    orderDetail: function orderDetail(a, b) {
      // console.log(a,'退费标准处罚')
      if (!this.showRevokeOrder) {
        return;
      }

      this.showDetail = a;
      var num = ''; // if(a.refundFee == null){
      // 	this.$message.error('该地区没有退费标准')
      // 	this.showDetail.orderCharge='没有退费标准'
      // 	this.showDetail.actualRefund='没有退费标准'
      // 	return
      // }

      this.$set(this.showDetail, 'actualRefund', Number(a.guaranteePrice) - Number(a.refundFee));
    }
  },
  mounted: function mounted() {
    if (this.orderDetail) {
      this.$set(this.showDetail, 'actualRefund', Number(this.orderDetail.guaranteePrice) - Number(this.orderDetail.refundFee));
    }
  },
  methods: {
    onChangeFile: function onChangeFile(file) {
      var ispdf = file.raw.type === 'application/pdf';

      if (!ispdf) {
        // this.fileList.pop()
        this.$message.error('请上传pdf格式的内容!');
        return false;
      }

      if (this.fileList.length > 0) {
        this.fileList.pop();
      }

      this.fileList.push(file);
    },
    handleRemove: function handleRemove(file) {
      this.fileList.pop();
    },
    // 处理撤销原因()
    handleReasonContent: function handleReasonContent() {
      var handleReason = this.reason.replace(/^\s+|\s+$/, "");

      if (handleReason === "") {
        this.isError = true;
        return false;
      }

      this.isError = false;
      return handleReason;
    },
    // 撤销原因失去焦点
    inputBlur: function inputBlur() {
      this.handleReasonContent();
    },
    sureClick: function sureClick() {
      var _this = this;

      var data1 = new Date(this.orderDetail.submitDocumentsDeadline.replace(/-/g, '/')).getTime();

      if (data1 <= new Date().getTime()) {
        this.$message.error('已开标项目不可提交撤销退款');
        return;
      } // 未写撤销原因不允许撤销


      if (this.isError) return;
      var handleReason = this.handleReasonContent();
      if (!handleReason) return;
      new Promise(function (resolve, reject) {
        if (_this.fileList.length != 0) {
          var flowNum = _this.userInfo.creditCode;
          var fileType = 'n' + new Date().getTime();
          var fileNum = 0;

          _this.publicMethed.upLoadImageC(_this.fileList[0], flowNum, fileType, fileNum, function (res) {
            resolve(res);
          }, function () {
            reject();
          });
        } else {
          resolve('');
        }
      }).then(function (res) {
        var data = {
          orderNo: _this.orderDetail.orderNo,
          enterpriseId: _this.userInfo.enterpriseId,
          userNo: _this.userInfo.userId,
          enterpriseName: _this.userInfo.enterpriseName,
          remark: handleReason,
          fileUrl: res
        };

        _this.requestAPI.cancelRefund(data).then(function (res) {
          _this.clickMask();

          _this.$message({
            message: '操作成功!',
            type: 'success'
          });

          _this.$emit("successShow");
        });
      });
    },
    clickMask: function clickMask() {
      this.$emit("cancelShow");
    }
  }
};